﻿import React from 'react';

import { BreadCrumbNavigation, StageBreadCrumb } from 'components/BreadCrumbNavigation/BreadCrumbNavigation';
import { OrderFillForm } from 'pages/partners/components/OrdersTab/components/OrderFillForm/OrderFillForm';
import type { AutoFillOption, OrderStageOption } from 'pages/partners/components/OrdersTab/OrdersTab';
import { PartnerDetails } from 'apis/PartnerApi';
import { Container } from 'react-bootstrap';
import { Order } from 'apis/OrderApi';

import 'components/RenewAnOrder/renew-an-order.scss';

interface RenewAnOrderProps {
	breadCrumbs: StageBreadCrumb<OrderStageOption>[];
	details: PartnerDetails;
	getAllOrdersFiltered: () => void;
	handleBreadCrumbClick: (currentBreadCrumb: StageBreadCrumb<OrderStageOption>) => void
    orderAutoFillOptions: AutoFillOption[];
    selectedOrder: Order;
    setOrderAutoFillOptions: React.Dispatch<React.SetStateAction<AutoFillOption[]>>;
}

export function RenewAnOrder({
    breadCrumbs,
    details,
    getAllOrdersFiltered,
    handleBreadCrumbClick,
    orderAutoFillOptions,
    selectedOrder,
    setOrderAutoFillOptions
}: RenewAnOrderProps) {

    return (
        <Container fluid>
            <BreadCrumbNavigation breadCrumbs={breadCrumbs} handleBreadCrumbClick={handleBreadCrumbClick} />
            <OrderFillForm
                details={details}
                getAllOrdersFiltered={getAllOrdersFiltered}
                orderableLicenses={[]}
                orderAutoFillOptions={orderAutoFillOptions}
                orderInventory={[]}
                page={{ selectedOrder, type: 'Renew' }}
                setOrderAutoFillOptions={setOrderAutoFillOptions}
            />
        </Container>
    );

}
